const MailLogger = {
    install(Vue) {
        Vue.mailLogSend = 0
        Vue.logApiLimitReached = function () {
            if(Vue.mailLogSend === 0){
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function() {
                    if (this.readyState == 4 && this.status == 200) {
                        // Typical action to be performed when the document is ready:
                        console.log('ApiError logged');
                    }
                };
                xhttp.open("GET", "https://www.autohaeuser-pohlheim.de/logautoscoutapierror", true);
                xhttp.send();
                Vue.mailLogSend = 1
            }
        }
    }
}

export default MailLogger